import React from 'react';

type AnimateSpinnerType = {
  customClasses?: string;
};

const AnimateSpinner = ({ customClasses }: AnimateSpinnerType) => (
  <div
    data-testid="loading-spinner"
    className={`${customClasses} loader ease-linear rounded-full border-4 border-t-4 border-gray-200 h-6 w-6`}
  />
);

export default AnimateSpinner;
